import { createIcon } from '../icon'
import SocksIcon from '../svg/SocksIcon'

export const SocksIconDefault = createIcon(SocksIcon)
